import requestAction from '../utils/requestAction'
import { pushAlert } from './alert'

export const notifyTeachers = requestAction('NOTIFY_TEACHERS')(
  `assignations/notify-teachers`, 'POST', undefined,
  (dispatch) => dispatch(pushAlert("DRs notificados"))
)
